var Omi = require('./omi11.js') ;

Omi.OmiFinger.init();

class Home extends Omi.Component {
	constructor(data) {
		super(data);
	}

	render() {
		return 	`
			<div>
				Home
			</div>
		`;
	}
};

Omi.tag('Home', Home);

class About extends Omi.Component {
	constructor(data) {
		super(data);
	}

	render() {
		return 	`
			<div>
				About
			</div>
		`;
	}
};

Omi.tag('About', About);

class UserList extends Omi.Component {
	constructor(data) {
		super(data);
	}

	render() {

		return `
			<ul>
				<li>
					<a omi-router to="/user/omi/category/html" href="">omi</a>
				</li>
				<li>
					<a omi-router to="/user/dnt/category/css" href="">dnt</a>
				</li>
				<li>
					<a omi-router to="/user/sorrowx/category/js" href="">sorrowx</a>
				</li>
			</ul>
		`;
	}
};

Omi.tag('UserList', UserList);

class User extends Omi.Component {
	constructor(data) {
		super(data);
	}

	beforeRender() {
		this.data.name = this.$store.$route.params.sName;
		this.data.category = this.$store.$route.params.sType;
		var info = this.queryInfo(this.data.name);
		this.data.age = info.age;
		this.data.sex = info.sex;
	}

	queryInfo(name) {
		this.mockData = {
			omi: {age: 1, sex: '女'},
			dnt: {age: 12, sex: '男'},
			sorrowx: {age: 13, sex: '男'},
		};

		return this.mockData[name];
	}

	back() {
		history.back();
	}

	render() {
		return `
			<div>
				<button omi-finger tap="back">back</button>
				<ul>
					<li>name: {{name}}</li>
					<li>age: {{age}}</li>
					<li>sex: {{sex}}</li>
					<li>category: {{category}}</li>
				</ul>
			</div>
		`;
	}
};

Omi.tag('User', User);

class App extends Omi.Component {
	constructor(data) {
		super(data);
	}

	install() {
		Omi.OmiRouter.init({
			routes: [
				{ path: '/', component: Home },
				{ path: '/about', component: About },
				{ path: '/user-list', component: UserList },
				{ path: '/user/:sName/category/:sType', component: User }
			],
			renderTo: "#view",
            defaultRoute: '/about',    // 默认
			root: this
		});
	}

	style() {
		return `
			ul{
			    border-bottom: 1px solid #ccc;
			    padding-bottom:5px;
			}
			li{
			    display:inline-block;
			}
			ul li a {
				text-decoration: none;
			}
			#view li{
			    display:block;
			}
			#view ul{
			    border-width: 0px;
			}
		`;
	}

	render() {
		return `
			<div>
				<ul>
					<li>
						<a omi-router to="/" href="">Home</a>
					</li>
					<li>
						<a omi-router to="/about" href="">About</a>
					</li>
					<li>
						<a omi-router to="/user-list" href="">用戶</a>
					</li>
				</ul>
				<div id="view"></div>
			</div>
		`;
	}
};

var app = new App();
Omi.render(app, '#app');


// WEBPACK FOOTER //
// ./js/entry.js